import { useEffect, useState, useCallback } from 'react';
import {
  switchWindow,
  updateWindowGeometry,
  updateWindowPosition,
} from '../redux/windowsSlice';
import { WindowSizes } from '../constants/windowSizes';
import {
  adjustWindowOnResize,
  adjustWindows,
  getAdjustedWindowGeometry,
} from '../helpers/adjustWindow';
import { AppWindow, WindowGeometry, WindowMetaData } from '../types';
import _ from 'lodash';
import { useAppDispatch } from '../../core/hooks/storeHooks';

export interface AppWindowProps {
  id: string;
  zIndex: number;
  isActive: boolean;
  topSectionSum: number;
  bottomSectionSum: number;
  maxHeight: number;
  maxWidth: number;
}

export type AppWindowMapProps = Omit<AppWindow, 'createdDate' | 'metaData'> & {
  metaData?: WindowMetaData;
};

export default (props: AppWindowProps & AppWindowMapProps) => {
  const [windowGeometry, setWindowGeometry] = useState({
    x: 0,
    y: 0,
    width: WindowSizes.minWidth,
    height: WindowSizes.minHeight,
  });
  const dispatch = useAppDispatch();

  // #region useEffects
  useEffect(() => {
    const originalGeometry = {
      x: props.x,
      y: props.y,
      width: props.width,
      height: props.height,
      isMaximized: props.isMaximized,
    };
    const newTempGeometry = getAdjustedWindowGeometry(
      originalGeometry,
      props.topSectionSum,
      props.bottomSectionSum,
      { width: props.maxWidth, height: props.maxHeight }
    );
    // let newTempGeometry = originalGeometry;
    // if (props.isMaximized) {
    //   newTempGeometry = {
    //     x: 0,
    //     y: props.topSectionSum,
    //     width: props.maxWidth,
    //     height: props.maxHeight,
    //   };
    // } else {
    //   newTempGeometry = adjustWindows(
    //     props.topSectionSum,
    //     props.bottomSectionSum,
    //     props.maxWidth,
    //     props.maxHeight,
    //     originalGeometry
    //   );
    // }
    if (!_.isEqual(windowGeometry, newTempGeometry))
      setWindowGeometry(newTempGeometry);
  }, [
    props.topSectionSum,
    props.bottomSectionSum,
    props.maxHeight,
    props.maxWidth,
    props.isMaximized,
  ]);
  // #endregion

  // #region functions
  const setActive = useCallback(() => dispatch(switchWindow(props.id)), []);

  // const onResizeStop = useCallback(() => {
  //   console.log('resizer stop', windowGeometry);
  //   dispatch(updateWindowGeometry({ id: props.id, geometry: windowGeometry }));
  // }, [props.id, windowGeometry]);

  const onResize = useCallback(
    (geometry: WindowGeometry, isStopped?: boolean) => {
      const newGeometry = adjustWindowOnResize(
        props.topSectionSum,
        props.bottomSectionSum,
        props.maxWidth,
        props.maxHeight,
        windowGeometry,
        geometry
      );
      if (isStopped)
        dispatch(updateWindowGeometry({ id: props.id, geometry: newGeometry }));
      else setWindowGeometry(newGeometry);
    },
    [
      props.topSectionSum,
      props.bottomSectionSum,
      props.maxWidth,
      props.maxHeight,
      windowGeometry,
    ]
  );

  const onDrag = useCallback(
    (x: number, y: number, e: MouseEvent, dragEnd?: boolean) => {
      const newAdjustments = adjustWindows(
        props.topSectionSum,
        props.bottomSectionSum,
        props.maxWidth,
        props.maxHeight,
        { ...windowGeometry, x, y }
      );
      const position = { x: newAdjustments.x, y: newAdjustments.y };

      if (dragEnd) dispatch(updateWindowPosition({ id: props.id, position }));
      else
        setWindowGeometry({
          ...windowGeometry,
          x: newAdjustments.x,
          y: newAdjustments.y,
        });
    },
    [
      props.topSectionSum,
      props.bottomSectionSum,
      props.maxWidth,
      props.maxHeight,
      windowGeometry,
    ]
  );
  // #endregion

  const controlBarProps = {
    x: windowGeometry.x,
    y: windowGeometry.y,
    onDrag,
  };
  // #endregion

  return {
    windowGeometry,
    onResize,
    // onResizeStop,
    setActive,
    // rndRef,
    // rndProps,
    controlBarProps,
    // onMoveEnd,
  };
};
